import { Heading, Text } from "@/design-system";
import { ArrowRight } from "lucide-react";
import { Link } from "react-router";
import { LEGAL_NAV } from "../content/company";
import type { LegalDocumentKey } from "../content/types";

type LegalRelatedDocsProps = {
  current: LegalDocumentKey;
};

/** "O assunto continua aqui": os outros documentos da área jurídica. */
export const LegalRelatedDocs = ({ current }: LegalRelatedDocsProps) => (
  <nav aria-labelledby="documentos-title" className="flex flex-col gap-6">
    <Heading level={2} size={3} id="documentos-title">
      Outros documentos
    </Heading>
    <ul className="grid gap-3 sm:grid-cols-2 lg:grid-cols-3">
      {LEGAL_NAV.filter(doc => doc.key !== current).map(doc => (
        <li key={doc.key}>
          <Link
            to={doc.path}
            className="group border-ds-border bg-ds-surface rounded-ds-lg hover:border-ds-brand-500 focus-visible:ring-ds-focus flex min-h-14 cursor-pointer items-center justify-between gap-3 border px-4 transition-colors duration-150 focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:outline-none motion-reduce:transition-none"
          >
            <Text as="span" weight="semibold">
              {doc.label}
            </Text>
            <ArrowRight
              aria-hidden="true"
              className="text-ds-ink-500 group-hover:text-ds-brand-700 size-5 shrink-0 transition-colors duration-150 motion-reduce:transition-none"
            />
          </Link>
        </li>
      ))}
    </ul>
  </nav>
);
